import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Condition } from 'Component/others';
import useGetHostScheduleDetail from 'Domain/host/useGetHostScheduleDetail';
import usePostCancelReschedule from 'Domain/reschedule/usePostCancelReschedule';
import { SkeletonButtonReschedule } from 'View/host-detail/component/skeleton';
import ButtonOutline from 'UiKit/button/buttonOutline';
import { TextSemiBold } from 'UiKit/typography';

import useCancelRescheduleModal from 'View/host-detail/hook/useCancelRescheduleModal';

import styles from './styles.module.css';

const ButtonReschedule = () => {
  const { t } = useTranslation('host-schedule');
  const { data, isFetching } = useGetHostScheduleDetail();
  const { mutate } = usePostCancelReschedule(data?.reschedule?.id);
  const navigate = useNavigate();
  const { onOpenModalCancelReschedule } = useCancelRescheduleModal();

  const isShowChange = data?.reschedule === null || data?.reschedule?.statusProgress !== 'Diproses';

  const onClick = () => {
    if (isShowChange) {
      navigate(`/reschedule-form/${data.id}`);
    } else {
      onOpenModalCancelReschedule(mutate);
    }
  };

  return (
    <Condition statement={!isFetching} fallback={<SkeletonButtonReschedule />}>
      <Condition statement={data?.isCanRequestReschedule}>
        <Box className={styles['reschedule-button__container']}>
          <ButtonOutline
            width={'100%'}
            borderWidth="1.5px"
            className={isShowChange ? styles['reschedule__button--change'] : styles['reschedule__button--cancel']}
            onClick={onClick}
          >
            <TextSemiBold className={styles['text__button']}>
              <Condition statement={isShowChange} fallback={t('action.cancel_reschedule')}>
                {t('action.change_schedule')}
              </Condition>
            </TextSemiBold>
          </ButtonOutline>
        </Box>
      </Condition>
    </Condition>
  );
};

export default ButtonReschedule;
